"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const SearchIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M19.7,18.9l-4.4-4.4c1-1.2,1.7-2.8,1.7-4.5c0-3.9-3.1-7-7-7c-3.9,0-7,3.1-7,7s3.1,7,7,7c1.4,0,2.7-0.4,3.8-1.2\n        l4.4,4.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3C20.1,19.9,20.1,19.3,19.7,18.9z M5,10c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5\n        S5,12.8,5,10z" })));
exports.SearchIcon = SearchIcon;
exports.default = exports.SearchIcon;
